import { LANGUAGES_BY_CODE } from '@sm/locale';
import { createURL } from '@sm/utils';

export const getHelpLinkLangFromCode = lang => {
  const helpLink = LANGUAGES_BY_CODE[lang] && LANGUAGES_BY_CODE[lang].helplink;
  const defaultHelpLink = LANGUAGES_BY_CODE.en.helplink;

  return helpLink || defaultHelpLink;
};

const getHelpLink = (lang, options = {}, userData = {}) => {
  const helpLang = getHelpLinkLangFromCode(lang);
  const domain = 'https://help.surveymonkey.com';
  let { articlePath, params } = options;
  const { helpName, featurePath, fragment } = options;
  if (!articlePath) articlePath = 'articles';
  if (!params) params = {};
  let path = `${domain}/${articlePath}/${helpLang}/kb/${helpName}`;
  if (featurePath) {
    path = `${domain}/${featurePath}`;
    params.l = helpLang;
  } else if (!helpName) {
    path = `${domain}/`;
    params.l = helpLang;
  }

  // add user info if available
  const { id, username, packageId, datacenterId } = userData;
  if (id && username && packageId && datacenterId) {
    const userDataString = `p__userid=${id}&p__username=${username}&p__packageid=${packageId}&p__datacenter=${datacenterId}`;
    // TODO: encrypt the `userDataString` before adding to the url! (WEBPLAT-793)
    Object.assign(params, { uid: userDataString });
  }

  let url = createURL(path, params);
  if (fragment) {
    url = `${url}#${fragment}`;
  }
  return url;
};

export default getHelpLink;
